/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Modal } from '../../canvasComponents/index';
// scss
import '../../css/components/PopUps/PopUps.scss';
// messages
import messages from './messages';

function FatalityPopUp(props) {
  return (
    <Modal
      ariaHideApp={false}
      id="fatalityModal"
      isOpen={props.open}
      onRequestClose={() => props.closeFatalityPopUp()}
    >
      <div>
        <div className="pop-up-title">
          <FormattedMessage {...messages.sorry} />
        </div>
        <div className="pop-up-text margin-text-bottom">
          <FormattedMessage {...messages.callIfYouPrefer} />
        </div>
        <Button
          primary
          className="pop-up-btn"
          onClick={() => props.closeFatalityPopUp()}
        >
          <FormattedMessage {...messages.continue} />
        </Button>
        <div className="fatality-pop-up-btn--wrapper">
          <Button className="fatality-pop-up-btn">
            <div className="fatality-pop-up-call">
              <a className="fatality-pop-up-call-btn" href="tel:1-844-766-6384">
                <FormattedMessage {...messages.callUs} /> 1-844-766-6384
              </a>
            </div>
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default injectIntl(FatalityPopUp);
